if (!customElements.get('meal-plan-klaviyo-signup')) {
  class MealPlanKlaviyoSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.handleSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      if (this.form && this.handleSubmit) {
        this.form.removeEventListener('submit', this.handleSubmit);
      }
    }

    handleSubmit(event) {
      const emailInput = this.form.querySelector('[data-klaviyo-email]');
      const firstNameInput = this.form.querySelector('[data-klaviyo-first-name]');
      const bridgeEvent = new CustomEvent('citruspear:klaviyo:signup', {
        bubbles: true,
        cancelable: true,
        detail: {
          email: emailInput ? emailInput.value.trim() : '',
          firstName: firstNameInput ? firstNameInput.value.trim() : '',
          listId: this.dataset.klaviyoListId || '',
          formId: this.dataset.klaviyoFormId || '',
          source: this.dataset.klaviyoSource || '',
          integrationMode: this.dataset.integrationMode || 'shopify_sync',
          consent: 'email',
          form: this.form,
        },
      });

      this.dispatchEvent(bridgeEvent);

      if (bridgeEvent.defaultPrevented) {
        event.preventDefault();
        this.form.setAttribute('aria-busy', 'true');
      }
    }
  }

  customElements.define('meal-plan-klaviyo-signup', MealPlanKlaviyoSignup);
}
